//@flow

export default {
  scrollToTop():boolean {
    const env = window || global;
    if (env.document) {
      env.document.documentElement && (env.document.documentElement.scrollTop = 0);
      env.document.body && (env.document.body.scrollTop = 0);
    }
    return false;
  },

  replace(url:string):void {
    window && window.location && window.location.replace && window.location.replace(url);
  },
};
